import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getServicesList, getServiceById } from "../services/DataService";
import { useTitle } from "../hook/useTitle";
import { ServiceCard } from "../components/Elements/ServiceCard";
import { Contact } from "./Contact/Contact";

export const ServiceDetail = () => {

    const [service, setService] = useState([]);
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [services, setServices] = useState([]);

    const navigate = useNavigate();

    useTitle(service.title);

    useEffect(() => {
        async function fetchService() {
            try {
                const data = await getServiceById(id);
                console.log(data)
                setService(data);

            } catch (err) {
                setError("une erreur est survenue lors de la récup des services");
            } finally {
                setLoading(false);
            }
        };
        fetchService();
    }, [id]);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const data = await getServicesList();
                setServices(data);
            } catch (err) {
                setError("une erreur est survenue lors de la récup des services");
            } finally {
                setLoading(false);
            }
        };
        fetchServices();
    }, [])

    const goHome = () => {
        navigate(`/`);
    }

    const handleClick = () => {
        navigate(`/nos-realisations`);
    };

    if (loading) return (
        <span className="loading loading-spinner text-secondary"></span>
    )
    if (!service || !service.title) {
        return <p>Chargement...</p>;
    }

    return (
        <section>
            <main>
                <button
                    className="btn btn-outline btn-sm my-3 ml-2 flex justify-start" onClick={goHome}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                    </svg>
                    retour
                </button>
                <article className="flex flex-col mb-3">
                    <img
                        src={service.cover}
                        alt="image-couverture-service"
                        className="rounded-tl-xl rounded-br-xl"
                    />
                    <h1 className="font-bold text-4xl mx-3 py-8 text-left text-accent">{service.title}</h1>
                    <p className="text-left mb-3 ml-2">{service.description}</p>
                    <p className="text-left mb-3 ml-2">Tous nos devis et conseils sont gratuits.</p>
                    <p className="text-left mb-3 ml-2">{service.text}</p>
                </article>
                <article className="flex flex-col items-center mb-3">
                    <button className="btn btn-outline btn-info btn-sm mx-8" onClick={handleClick}>Retrouvez nos réalisations en photos</button>
                </article>
                <article className="flex flex-wrap gap-2 mx-3 py-8">
                    <button className="btn btn-primary no-animation rounded-full">TOUS</button>
                    {service.tags.map(tag => (
                        <button className="btn btn-primary no-animation rounded-full btn-outline">
                            {tag}
                        </button>
                    ))
                    }
                </article>

                <article className="services">
                    <h1 className="text-secondary font-bold text-4xl text-left mx-3 py-8"><b>Nos</b> <i>autres services</i></h1>
                    <article>
                        <div className="carousel w-full gap-2">
                            {services.filter(service => service.id !== id).map(filteredService => (
                                <ServiceCard
                                    key={filteredService.id}
                                    service={filteredService}
                                />
                            ))}
                        </div>
                    </article>
                </article>

                <article className="mb-3">
                    <Contact />
                </article>

            </main>
        </section>
    );
};
